import { computed, ref } from 'vue'

import { STORAGE } from '../api/client'

/**
 * Si esta persona quiere que las pantallas le ofrezcan su tutorial.
 *
 * ── Por qué es de la PERSONA y no de la empresa ──────────────────────────────
 *
 * En la misma casa conviven quien entró ayer y quien lleva tres años. Una ayuda
 * que se enciende para todos a la vez es ruido para la mitad, y una que se
 * enciende para nadie es una ayuda que no existe. Así que vive en el perfil, al
 * lado del idioma: cada cual decide, y le sigue al móvil y al portátil porque
 * viaja en su usuario y no en el navegador.
 *
 * Encendido por defecto. Una ayuda que solo aparece si ya sabías que existe y
 * fuiste a encenderla no la encuentra nadie; apagarla es un interruptor.
 *
 * ── Por qué se lee de aquí y no del store de auth ────────────────────────────
 *
 * Porque esto es el ui-kit y no puede importar de `@general/auth` — sería el
 * componente más bajo dependiendo del módulo que lo usa. La copia del perfil ya
 * está guardada bajo una clave que es de este paquete (`STORAGE.user`, en
 * `api/client.js`), así que se lee de ahí.
 *
 * Se cachea en un `ref` y no se lee en cada pintado: `localStorage` es síncrono
 * y una cabecera que lo consulte en cada repintado paga ese coste en todas.
 */

const stored = ref(read())

function read() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE.user) ?? 'null')
  } catch {
    // Una ventana privada, el almacenamiento bloqueado, un JSON a medias. Sin
    // perfil no hay preferencia, y sin preferencia el tutorial se ofrece: es el
    // valor por defecto, y el caso en que más falta hace.
    return null
  }
}

/** Si hay que ofrecer los tutoriales. */
export const tutorialsOn = computed(() => stored.value?.showTutorials !== false)

/**
 * Vuelve a leer el perfil guardado.
 *
 * Lo llama quien lo cambia —la pantalla de perfil— para que el interruptor se
 * note en la cabecera sin recargar. Sin esto, apagar los tutoriales dejaría los
 * «?» puestos hasta el siguiente arranque, que es la clase de cosa que hace
 * dudar de si el interruptor hizo algo.
 */
export function refreshTutorials() {
  stored.value = read()
}

export function useTutorials() {
  return { tutorialsOn, refresh: refreshTutorials }
}
